import React from 'react';
import { withRouter } from 'react-router-dom';
import { Trans, t } from '@lingui/macro';
import { i18n } from '@lingui/core';

import {
    Container,
    Grid,
    Column,
    Section,
    Card,
    Actions,
    Pictorials,
    Typography,
} from 'components';

import { URLS, PATHS } from 'config';
import { StyledPictorial, StyledLink } from 'components/StyledCommon';

const Page = ({ history }) => {
    return (
        <Section topMargin minHeight="100vh">
            <Container>
                <Grid alignCenter>
                    <Column cols={8} desktop={7} tablet={10}>
                        <Card>
                            <StyledPictorial
                                color="error"
                                icon={Pictorials.Error}
                            />

                            <Typography variant="h5" spaceBottom="base">
                                <Trans>Something went wrong</Trans>
                            </Typography>

                            <Typography variant="bodys" spaceBottom="large">
                                <Trans>
                                    We couldn’t load the page you were looking
                                    for. Please try again later.
                                </Trans>
                                <br />
                                <Trans>
                                    If you still have trouble, please contact
                                    our{' '}
                                    <StyledLink
                                        $size="bodys"
                                        href={URLS.supportNew}
                                    >
                                        Support team
                                    </StyledLink>{' '}
                                    for help.
                                </Trans>
                            </Typography>

                            <Actions
                                align="center"
                                primary={{
                                    children: i18n._(t`Back to homepage`),
                                    onClick: () => {
                                        history.push(PATHS.dashboard);
                                    },
                                }}
                            />
                        </Card>
                    </Column>
                </Grid>
            </Container>
        </Section>
    );
};

export default withRouter(Page);
